export default {"src":"/_next/static/media/grafbase.9236ae5b.svg","height":22,"width":88,"blurWidth":0,"blurHeight":0};